import { render, staticRenderFns } from "./DeliverableAssetsManagement.vue?vue&type=template&id=f46d69d0&scoped=true"
import script from "./DeliverableAssetsManagement.vue?vue&type=script&lang=js"
export * from "./DeliverableAssetsManagement.vue?vue&type=script&lang=js"
import style0 from "./DeliverableAssetsManagement.vue?vue&type=style&index=0&id=f46d69d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46d69d0",
  null
  
)

export default component.exports